import React from 'react'

function DepartmentMaster() {
  return (
    <div>Department Master</div>
  )
}

export default DepartmentMaster